<template>
  <div class="notification-wrapper">
    <div class="image-wrapper">
      <img :src="shopImage" alt="" />
    </div>
    <div class="notification-info">
      <div class="title" v-html="notification.message"></div>
      <div class="date">{{ notification.createdAt | moment("from") }}</div>
    </div>
    <div class="new" :class="{ isUnread: isNotificationUnread }"></div>

    <!-- <div class="product-preview">
      <img src="https://i.ytimg.com/vi/SiyGdOHobsY/hqdefault.jpg" alt="" />
    </div> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "NotificationMenuItem",
  props: {
    notification: {
      type: Object,
    },
  },
  computed: {
    ...mapGetters({
      getFollowedShopFromId: "shop/getFollowedShopFromId",
    }),
    isNotificationUnread() {
      return this.notification.isUnread;
    },
    shopImage() {
      const shop = this.getFollowedShopFromId(this.notification.shopId);
      if (shop) {
        return shop.thumbnail;
      }
      return null;
    },
  },
};
</script>

<style lang="scss" scoped>
.notification-wrapper {
  position: relative;
  padding: 16px 0;
  display: flex;
  flex-direction: row;
  flex: 1;
  .new {
    background-color: transparent;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    margin: 22px 22px 0;
    &.isUnread {
      background-color: red;
      // background-color: $primary1;
    }
  }
  .image-wrapper {
    height: 48px;
    width: 48px;
    margin-left: 16px;
    margin-right: 16px;
    flex: none;
    border-radius: 50%;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  .notification-info {
    color: black;
    min-width: 0;
    flex: 1;
    display: flex;
    flex-direction: column;
    .title {
      color: black;
      margin-bottom: 8px;
      max-height: 12rem;
      overflow: hidden;
      font-size: 14px;
    }
    .date {
      color: #666;
      font-size: 12px;
    }
  }
  .product-preview {
    margin: 0 16px;
    width: 86px;
    height: 48px;
    position: relative;
    overflow: hidden;
    flex: none;
    img {
      position: absolute;
      transform: translateY(-50%);
      top: 50%;
      left: 0;
      width: 100%;
    }
  }
}
</style>
